interface ScreenConfig {
  personal: string;
  primary: string;
  published: string;
  sections: string;
  memberTags: string;
  otherStateBar: string;
  adminUserConfiguration: string;
  jobConfiguration: string;
  memberCodeAdvancementConfiguration:string;
  pendingPaymentsConfiguration:string;
  adminUserCreationConfiguration: string;
  createOrder: string;
  updatePayment: string;
  viewOrder: string;
  orderList: string;
  editOrder: string;
  createEvent: string;
  createVideoEvent: string;
  viewEvent: string;
  eventList: string;
  editEvent: string;
  memberTypeConfiguration: string;
  memberCodeConfiguration: string;
  memberTagConfiguration: string;
  memberSectionConfiguration: string;
  FirmManagementConfiguration: string;
  LocationConfiguration: string;
  CostConfiguration: string;
  HelpVideosConfiguration: string;
  adminUserListScreen: string;
  adminUserCreateScreen: string;
  adminUserEditScreenn: string;
  memberListScreen: string;
  sendEmailScreen: string;
  printLabelScreen: string;
  memberCreateScreen: string;
  memberFindScreen: string;
  memberDetailScreen: string;
  memberEditPersonalInfoScreen: string;
  memberEditPrimaryAddressScreen: string;
  memberEditPublishedAddressScreen: string;
  memberEditSessionInfoScreen: string;
  memberEditMemberTagScreen: string;
  savedSearchList: string;
  memberEditFirmDetailScreen: string;
  memberEditOtherStateBarScreen: string;
  findMemberListSavedQuery: string;
}

export const screenConfig: ScreenConfig = {
  personal: "Personal",
  primary: "Primary",
  published: "Published",
  sections: "Sections",
  memberTags: "MemberTags",
  otherStateBar: "OtherStateBar",
  adminUserConfiguration: "AdminUserConfiguration",
  adminUserCreationConfiguration: "AdminUserCreationConfiguration",
  memberTypeConfiguration: "MemberTypeConfiguration",
  memberCodeConfiguration: "MemberCodeConfiguration",
  memberTagConfiguration: "MemberTagConfiguration",
  memberSectionConfiguration: "MemberSectionConfiguration",
  FirmManagementConfiguration: "FirmManagementConfiguration",
  LocationConfiguration: "LocationConfiguration",
  CostConfiguration: "CostConfiguration",
  HelpVideosConfiguration: "HelpVideosConfiguration",
  adminUserListScreen: "AdminUserListScreen",
  adminUserCreateScreen: "AdminUserCreateScreen",
  adminUserEditScreenn: "AdminUserEditScreenn",
  jobConfiguration:"JobConfiguration",
  createOrder: "CreateOrder",
  updatePayment: "UpdatePayment",
  viewOrder: "ViewOrder",
  orderList: "OrderList",
  editOrder: "EditOrder",
  createEvent: "CreateEvent",
  createVideoEvent: "CreateVideoEvent",
  viewEvent: "ViewEvent",
  eventList: "EventList",
  editEvent: "EditEvent",
  memberListScreen: "MemberListScreen",
  memberCreateScreen: "MemberCreateScreen",
  memberFindScreen: "MemberFindScreen",
  memberDetailScreen: "MemberDetailScreen",
  memberEditPersonalInfoScreen: "MemberEditPersonalInfoScreen",
  memberEditPrimaryAddressScreen: "MemberEditPrimaryAddressScreen",
  memberEditPublishedAddressScreen: "MemberEditPublishedAddressScreen",
  memberEditSessionInfoScreen: "MemberEditSessionInfoScreen",
  memberEditMemberTagScreen: "MemberEditMemberTagScreen",
  savedSearchList: "SavedSearchList",
  memberEditFirmDetailScreen: "MemberEditFirmDetailScreen",
  memberEditOtherStateBarScreen: "MemberEditOtherStateBarScreen",
  findMemberListSavedQuery: "FindMemberListSavedQuery",
  sendEmailScreen: "sendEmailScreen",
  printLabelScreen: "PrintLableScreen",
  memberCodeAdvancementConfiguration:"MemberCodeAdvancementConfiguration",
  pendingPaymentsConfiguration:"PendingPaymentsConfiguration"
};
